<div class="finances position-relative">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="back-btn d-flex align-items-center" [routerLink]="['/admin', 'dashboard']">
          <img src="/assets/images/icons/back.svg" class="cursor-pointer"/>
          <p class="title-back mb-0 fs-16 cursor-pointer">{{'back' | translate}}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <h1 class="fs-32 fw-bold mb-3"> {{'finances' | translate}}</h1>
          <div class="text-start d-flex align-items-center">
            <div
              class="fs-16 fw-bold need-help me-2 text-center">{{'switch_to' | translate}} {{payoutType === 'seller' ?  ('affiliate_user' | translate) :  ('seller' | translate)}}</div>
            <label class="action-switch-green-btn m-0">
              <input type="checkbox" (click)="enableChanged($event)" [checked]="payoutType === 'user'">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="tab-content">
          <div class="tab-pane fade show active" id="payout" role="tabpanel" aria-labelledby="payout-tab">
            <div class="finances-list">
              <div class="wallet-balance">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-4 text-center">
                      <h6 class="fs-14">{{'total_revenue' | translate}}</h6>
                      <kwot-currency [price]="vendorPayoutTransactionDetail?.totalRevenue || 0" tag="h2" class="fs-24 fw-bold" [hasField]="false"
                                     [platformFee]="false"></kwot-currency>
                    </div>
                    <div class="col-md-4 text-center">
                      <h6 class="fs-14">{{'net_revenue' | translate}}</h6>
                      <kwot-currency [price]="vendorPayoutTransactionDetail?.netRevenue || 0" tag="h2" class="fs-24 fw-bold" [hasField]="false"
                                     [platformFee]="false"></kwot-currency>
                    </div>
                    <div class="col-md-4 text-center">
                      <h6 class="fs-14">{{'sellers_profit' | translate}}</h6>
                      <kwot-currency [price]="vendorPayoutTransactionDetail?.sellerProfit || 0" tag="h2" class="fs-24 fw-bold" [hasField]="false"
                                     [platformFee]="false"></kwot-currency>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-fluid" *ngIf="checkData()">
                <div class="row mt-4">
                  <div class="col-md-6"></div>
                  <div class="col-md-4 align-self-center">
                    <div class="form-group mb-0">
                      <div class="left-header d-md-block d-none">
                        <div class="form-group  mb-0">
                          <input type="text"
                                 placeholder="Add currency rate for NGN"
                                 class="form-control br-16" [(ngModel)]="currencyRate">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 align-self-center">
                    <div class="export">
                      <button class="btn-action export-btn"
                              [ngClass]="{'btn-disabled': !currencyRate, 'btn-action': currencyRate}"
                              (click)="currencyRate ? getCSVFile() : ''"> {{'export' | translate}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-fluid">
                <form [formGroup]="dateFilter">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group">
                        <div class="left-header d-md-block d-none">
                          <div class="form-group mb-0">
                            <div class="position-relative">
                              <img src="/assets/images/icons/search-icon.svg" class="search-icon status-search" alt="">
                              <input type="search" class="form-control br-16 search-input"
                                     placeholder="{{'search_name_status' | translate}}"
                                     (keyup)="search($event)">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label class="form-label fs-12 m-0">{{'date_range' | translate}}</label>
                        <kwot-custom-select
                          class="filter-wallet-data"
                          [searchable]="true"
                          [placeholder]="('select_date' | translate)"
                          [selectOptions]="month"
                          selectedValue="monthRange"
                          (optionSelected)="filterWalletData()"
                          [formGroup]="dateFilter">
                        </kwot-custom-select>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="container-fluid">
                <div class="row">
                  <div class="finance-table">
                    <div class="custom-table finances-table">
                      <kwot-custom-table
                        #customTableComponent
                        [customOptions]="customDatatableSettings"
                        [tableHead]="tableHead"
                        [ajaxFunction]="getAllWalletTransaction"
                        [tableBody]="tableBody">
                      </kwot-custom-table>
                      <ng-template #tableHead>
                        <thead>
                        <tr>
                          <td>
                            <p
                              class="title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details">
                              {{'seller_name' | translate}}
                            </p>
                          </td>
                          <td>
                            <p
                              class="title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details">
                              {{'transactions_date' | translate}}
                            </p>
                          </td>
                          <td>
                            <p
                              class="title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details">
                              {{'amount' | translate}}
                            </p>
                          </td>
                          <td>
                            <p
                              class="title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details">
                              {{'status' | translate}}
                            </p>
                          </td>
                        </tr>
                        </thead>
                      </ng-template>
                      <ng-template #tableBody>
                        <tbody *ngIf="monthlyTransactionList.length <= 0">
                        <tr>
                          <td colspan="4">{{'no_data_found' | translate}}</td>
                        </tr>
                        </tbody>
                        <tbody *ngIf="monthlyTransactionList.length > 0">

                        <ng-container *ngFor="let transaction of monthlyTransactionList">
                          <tr *ngIf="transaction.type === 'group'; else listTemplate" class="group">
                            <td colspan="4">{{transaction.value}}</td>
                          </tr>
                          <ng-template #listTemplate>
                            <tr>
                              <td>
                                <p class="mb-0 fs-16 store-content-details" *ngIf="payoutType === 'seller'">
                                  {{transaction?.vendorId?.name}}
                                </p>
                                <p class="mb-0 fs-16 store-content-details" *ngIf="payoutType === 'user'">
                                  {{transaction?.userId?.firstName}} {{transaction?.userId?.lastName}}
                                </p>
                              </td>
                              <td>
                                <p class="mb-0 fs-16 store-content-details">
                                  {{transaction?.createdAt | date: 'dd/MM/yyyy'}}
                                </p>
                              </td>
                              <td>
                                <kwot-currency [price]="transaction" tag="p" type="wallet" *ngIf="payoutType === 'user'"
                                               class="mb-0 fs-16 store-content-details" field="amount"
                                               [platformFee]="false"></kwot-currency>
                                <kwot-currency [price]="transaction?.amount || 0" *ngIf="payoutType === 'seller'"
                                               [item]="transaction.vendorId" tag="p" type="wallet" [hasField]="false"
                                               class="mb-0 fs-16 store-content-details" field="amount"
                                               [platformFee]="false"></kwot-currency>
                              </td>
                              <td *ngIf="transaction.status == 'ON HOLD'">
                                <kwot-custom-select
                                  class="status-data"
                                  [searchable]="true"
                                  [isDisabled]="!checkData()"
                                  placeholder="{{ 'select_status' | translate }}"
                                  (optionSelected)="statusData(transaction._id)"
                                  [selectOptions]="status"
                                  [(selectedValue)]="transaction.status"
                                >
                                </kwot-custom-select>
                              </td>
                              <td *ngIf="transaction.status == 'PENDING' || transaction.status == 'PAID'">
                                <p class="mb-0 fs-16 store-content-details">
                                  {{transaction.status}}
                                </p>
                              </td>
                            </tr>
                          </ng-template>
                        </ng-container>
                        </tbody>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
